import { Link } from "react-router-dom"
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa"

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 lg:px-8 py-14">

        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">

          {/* Entreprise */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/favicon.jpg"
                alt="Khenissi Textile"
                className="h-12 w-auto"
              />

              <div>
                <h3 className="text-white font-bold text-lg">
                  KHENISSI
                </h3>

                <p className="text-xs uppercase tracking-wider text-gray-400">
                  Textile & Mercerie
                </p>
              </div>
            </div>

            <p className="text-sm leading-relaxed text-gray-400">
              Grossiste spécialisé dans les fournitures textiles,
              mercerie, tissus, fils à coudre, fermetures,
              velcro, boutons et accessoires pour les professionnels.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">
              Navigation
            </h3>

            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="hover:text-white transition"
                >
                  Accueil
                </Link>
              </li>

              <li>
                <Link
                  to="/categories"
                  className="hover:text-white transition"
                >
                  Catégories
                </Link>
              </li>

              <li>
                <Link
                  to="/produits"
                  className="hover:text-white transition"
                >
                  Produits
                </Link>
              </li>

              <li>
                <Link
                  to="/a-propos"
                  className="hover:text-white transition"
                >
                  À Propos
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="hover:text-white transition"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Catégories */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">
              Nos Catégories
            </h3>

            <ul className="space-y-3 text-gray-400">
              <li>Fermetures</li>
              <li>Élastiques</li>
              <li>Fils</li>
              <li>Tissus</li>
              <li>Velcro</li>
              <li>Boutons</li>
              <li>Accessoires Rideaux</li>
              <li>Ciseaux</li>
              <li>Accessoires Tapissier</li>
              <li>Divers</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">
              Contact
            </h3>

            <ul className="space-y-4">

              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <span>
                  12 Rue des Tanneurs, Tunis, Tunisie
                </span>
              </li>

              <li className="flex items-center gap-3">
                <FaPhoneAlt />
                <a
                  href="tel:+21628718432"
                  className="hover:text-white transition"
                >
                  +216 28 718 432
                </a>
              </li>

              <li className="flex items-center gap-3">
                <FaEnvelope />
                <a
                  href="mailto:khenissi.khaled23@gmail.com"
                  className="hover:text-white transition break-all"
                >
                  khenissi.khaled23@gmail.com
                </a>
              </li>

              <li>
                <a
                  href="https://wa.me/21628718432"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg text-white transition"
                >
                  <FaWhatsapp />
                  WhatsApp
                </a>
              </li>

            </ul>
          </div>

        </div>

        {/* Liens légaux */}
        <div className="border-t border-gray-800 mt-12 pt-6">

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm">

            <Link
              to="/politique-confidentialite"
              className="hover:text-white transition"
            >
              Politique de confidentialité
            </Link>

            <span className="hidden md:block text-gray-600">
              •
            </span>

            <Link
              to="/conditions-generales"
              className="hover:text-white transition"
            >
              Conditions générales d'utilisation
            </Link>

          </div>

          <p className="text-center text-gray-500 text-sm mt-6">
            © {year} Khenissi Textile. Tous droits réservés.
          </p>

        </div>

      </div>
    </footer>
  )
}